import { PORTAL_RECEIVED_GET_POLICY_DOCUMENT } from '../../legacy/actions/portal-actions';
import { legacyFulfill } from '../utils';
import { BuilderType, portalCacheTags } from './portalApiHelpers';

export type Profile = {};

interface PolicyDocumentResponse {
  account_users: any[];
  email: string;
  first_name: string;
  groups: any[];
  id: number;
  last_name: string;
  locale: string;
  policy_definitions: object;
}

export const userProfileApi = (builder: BuilderType) => ({
  // prettier-ignore
  updateUserProfileImage: builder.mutation<Profile,{ id: string; image: string }>({
    query: ({ id, image }) => ({
      method: "POST",
      url: `/service/user-profile-images/${id}`,
      body: { profile_image: image },
    }),
    invalidatesTags: [portalCacheTags.USER_PROFILE],
  }),

  getPolicyDocument: builder.query<PolicyDocumentResponse, void>({
    query: () => `service/policy-documents`,
    onQueryStarted: legacyFulfill(PORTAL_RECEIVED_GET_POLICY_DOCUMENT),
  }),
});
